import $ from 'jquery';
import Stack from './graphics/Stack.js';
import ByType from './graphics/ByType.js';
import Horizontal from './graphics/Horizontal.js';
import Bar from './graphics/Bar.js';

/**
 * A utilização do Classe requer a declaração dos elementos
 * declarados abaixo para seu funcionamento adequado
 */

const dataInicialElement = document.querySelector('#dataInicial');
const dataFinalElement = document.querySelector('#dataFinal');
const moedaElement = document.querySelector('#idMoeda');
const statusElement = document.querySelector('#status');
const centrosCustoElement = document.querySelector('#centrosCusto');
const projetosElement = document.querySelector('#projetos');
// Botões que definem o intervalo de exibição dos dados mensal/trimestral/anual
const buttonInterval = document.querySelectorAll('.button-graphic-interval');
// Classe que o botão de intervalo deve receber quando estiver ativo
const classButtonActive = 'form-interval__button--active';


// let niftyActive = false;

$('.graphic-progress').addClass('graphic-progress--load');

/**
 * Classe responsável por carregar os grafícos,
 * definir propriedades e atribuir interatividade
 * relacionada a pequisa e reload dos gráficos,
 * como também proporcionar a interação com relação
 * ao intervalo que os dados são exibidos,
 * escolha de tipo de gráfico para instância
 * mais automatizada.
 */
class Graphics {
  /**
   * url em que a classe deve ser incorporada
   * @type {RegExp}
   */
  static url = /^\/admin\/dashboard-graficos/g;

  /**
   * Instancia da classe
   *
   * @param  {String} formSelector  ID do formulário contém os filtros do gráfico
   * @param  {String} graphicClass  classe do canvas onde será criado o gráfico
   * @param  {String} graphicProgress classe relacionada ao load do gráfico
   *
   *  @return {class}
   */
  static init(formSelector, graphicClass, graphicProgress = '.graphic-progress') {
    Graphics.graphic = new Graphics(formSelector, graphicClass, graphicProgress);
    return window.graphic;
  }


  /**
   * Irá conter como atributo de classe
   * todos os gráficos intanciados e suas propriesdades
   * Dispara o método de carregamento de todos os gráficos
   * definidos na página html
   * Inicia o Listener do Formulário.
   *
   * @param  {String} formSelector    ID do formulário que contém os filtros do gráfico
   * @param  {String} graphicClass    classe do canvas onde será criado o gráfico
   * @param  {String} graphicProgress classe relacionada ao load do gráfico
   *
   * @return {void}
   */
  constructor(formSelector, graphicClass, graphicProgress = '.graphic-progress') {
    this.formFilter = document.querySelector(formSelector);
    this.graphicClass = graphicClass;
    this.graphics = {};
    this.graphicProgress = graphicProgress;
    this.loadGraphicsAll();
    this.addListenerFilter();
  }

  /**
   * Event Listerner Form Submit
   * Percorre o atributo da classe que cotem os
   * gráficos instanciados, para cada gráfico armazenado
   * realiza a request e chama o método de atualização
   * dos dados.
   */
  addListenerFilter() {
    this.formFilter.addEventListener('submit', (e) => {
      e.preventDefault();
      $(this.graphicProgress).addClass('graphic-progress--load');
      const graphics = Object.keys(this.graphics).map((key) => {
        return this.graphics[key];
      });
      graphics.forEach((currentGraphic) => {
        currentGraphic.graphic.destroy();
      })
      this.graphics = {};
      this.loadGraphicsAll();
    });
  }

  /**
   * Event Listener de alteração de intervalo
   * Percorre todos os botões com a classe que seta o
   * intervalo dos dados apresentados, adicionando o
   * evento de click.
   *
   * @param {null} changeInterval
   */
  addEventListenerInterval(changeInterval) {
    // se o botão não possuir o valor nullo, quer dizer que ele
    // foi clicado, por isso não adicona o listener
    if (!changeInterval) {
      buttonInterval.forEach((button) => {
        button.addEventListener('click', () => {
          this.changeIntervalGraphic(button);
        });
      });
    }
  }

  /**
   * Envento de click na alteração do intervalo dos dados
   * Recupera os dados informados por meio dos data-graphic
   * como nome do graphic e intervalo, obrigatórios para o
   * funcionamento. Este método altera o valor do atributo
   * data do gráfico referente ao seu intervalo, sem seguida
   * destroy a instância do gráfico no atributo de gráficos
   * da classe e chama o método para criar um novo gráfico,
   * agora o o intervalo redefinido. Depois dispara o método
   * que troca a classe do botão ativo no menu de intervalos.
   *
   * @param  {element} button
   * @return {void}
   */
  changeIntervalGraphic(button) {
    const graphicName = button.getAttribute('data-graphic-owner');
    const interval = button.getAttribute('data-graphic-interval');
    this.graphics[graphicName].element.setAttribute('data-graphic-interval', interval);
    const classGraphic = this.graphics[graphicName].classObject.data;
    // Limpando os dados da classe do gráfico
    this.graphics[graphicName].classObject.data = null;
    this.graphics[graphicName].graphic.destroy();
    // este true garante que a adição do Event Listener não seja disaparada
    this.createGraphic(this.graphics[graphicName], classGraphic, true);
    this.addClassActiveButton(button, graphicName);
  }

  /**
   * Adicionar/Remover Classe de botão de Intervalo ativo
   * Capitura todos os botões que contenham como seu proprietário
   * o gráfico que foi alterado por ele, percorre os botões encontados
   * removendo a classe de botão ativo, em seguida adiciona a classe
   * de ativio no botão que disparou o evento.
   *
   * @param {element} button      botão que receberá a classe --active
   * @param {string} graphicName
   */
  addClassActiveButton(button, graphicName) {
    const buttons = document.querySelectorAll('[data-graphic-owner=\'' + graphicName + '\']');
    buttons.forEach((currentButton) => {
      currentButton.classList.remove(classButtonActive);
    });
    button.classList.add(classButtonActive);
  }

  /**
   * Removendo a classe de gráfico não criado
   * @param  {element} element
   */
  graphicCreated(element) {
    const contentHolder = element.parentNode;
    contentHolder.classList.remove('graphic__wrapper--not-loaded');
  }

  /**
   * Adicionando a classe de gráfico não criado
   * @param  {element} element
   */
  graphicNotCreate(element) {
    const contentHolder = element.parentNode;
    contentHolder.classList.add('graphic__wrapper--not-loaded');
  }

  /**
   * Removendo a classe de Gráfico em carregamento
   * @param  {element} element
   */
  graphicRemoveLoadClass(element) {
    $(element).parent().find('.graphic-progress').removeClass('graphic-progress--load');
  }

  /**
   * Captura os dados que estão contidos no fromulário
   * de fitro, para uma pesquisa de dados
   *
   * @return {Object} Dados do formulário
   */
  getParamsFilterRequest() {
    const status = statusElement.selectize;
    const centrosCusto = centrosCustoElement.selectize;
    const projetos = projetosElement.selectize;
    const data = new FormData();

    data.append('dataInicial', dataInicialElement.value);
    data.append('dataFinal', dataFinalElement.value);
    data.append('idMoeda', moedaElement.value);
    status.getValue().forEach((index) => {
      data.append('status[]', index);
    });
    centrosCusto.getValue().forEach((index) => {
      data.append('centrosCusto[]', index);
    });
    projetos.getValue().forEach((index) => {
      data.append('projetos[]', index);
    });
    return data;
  }

  /**
   * Disparar a requisição para o servidor
   * Utiliza o métod POST, Identifica o
   * nome da Url no Laravel e faz a conversão,
   * não é sincrona, para evitar que os gráficos
   * sejam instanciados sem dados
   *
   * @param  {string} url Nome da Url no Laravel
   * @return {Object}     Response Json|False
   */
  sendRequest(url, method, data) {
    return $.ajax({
      url: route(url),
      method: method,
      data: data
    });
  }

  /**
   * Armena os dados do atributo graphics da Classe,
   * seguindo um padrão de Objeto
   *
   * @param  {string} nameGraphic Nome do gráfico
   * @param  {string} graphicType Tipo de Gráfico
   * @param  {element} element     O elemento Html
   * @param  {string} urlName     O nome da URL no Laravel
   *
   * @return {void}
   */
  registerGraphicAtttibuteClass(nameGraphic, graphicType, element, urlName) {
    this.graphics[nameGraphic] = {
      nameGraphic: nameGraphic,
      graphicType: graphicType,
      element: element,
      urlName: urlName,
      classObject: null,
      graphic: null
    };
  }

  /**
   * realizando a request e chamando a instância de
   * gráfico
   *
   * @param  {element} element
   */
  baseFunctionCallRequest(element) {
    const graphicType = element.getAttribute('data-graphic-type');
    const nameGraphic = element.getAttribute('data-graphic-name');
    const urlName = element.getAttribute('data-graphic-route');
    const inputs = {
      '_token': $('[name=_token]').val(),
      'dataInicial': $('#dataInicial').val(),
      'dataFinal': $('#dataFinal').val(),
      'idMoeda': $('#idMoeda').val(),
      'status': $('#status').val() ? $('#status').val() : [],
      'centrosCusto': $('#centrosCusto').val() ? $('#centrosCusto').val() : [],
      'projetos': $('#projetos').val() ? $('#projetos').val() : []
    }

    const request = this.sendRequest(urlName, 'POST', inputs);

    request.done((response) => {
      this.registerGraphicAtttibuteClass(nameGraphic, graphicType, element, urlName);
      this.createGraphic(this.graphics[nameGraphic], response);
      this.graphicRemoveLoadClass(element);
    }).fail((error) => {
      this.graphicNotCreate(element);
      this.graphicRemoveLoadClass(element);

      if (error.status === 401) {
        window.location.replace(route('app.login', { 'unauthorized': true }));
      }
    });
  }

  /**
   * Método que perocorre todos os elementos dá página que estão
   * marcados para conter um gráfico, capitura os data-atributes
   * de cada um deles, como Tipo de Gráfico, Nome do Gráfico, Nome
   * da URL. Dispara o método de requisição para o serividor, chama
   * o método que registra do dados no atributo da classe e chama o método
   * para  acrição do gráfico
   */
  loadGraphicsAll() {
    const elements = document.querySelectorAll(this.graphicClass);
    const promises = [];

    elements.forEach(element => {
      promises.push(
        new Promise((resolve, reject) => {
          try {
            this.baseFunctionCallRequest(element);
          } catch (e) {
            reject(e);
          }
          resolve();
        }))
    });

    Promise.all(promises);
  };


  /**
   * Chamar o método da classe para Preparar os dados
   * do gráfico
   *
   * Realiza a definição do tipo de intervalo utilizado
   * no gráfico, se o intevalo possuir um tipo, como
   * mensal/trimestral/anual,  chama o método que prepara
   * os dados de acordo como o periodo informado na
   * data-graphic-interval posterior a isso adiciona o
   * listerner nos botões que altera o intervalo de exibição,
   * se nenhum valor dentro os periodos listados forém
   * encontados, assumi que não existe a alteração de um
   * período, defini então o limite de colunas e dados que
   * seram exibidos no gráfico por meio da data-graphic-limit,
   * caso não tena o valor, assumi como default o '9'.
   * Após as validação, ele chama o metodo de preparação dos dados
   * que existem em cada uma das classes de tipos de gráficos
   *
   * @param  {element} element        Elemento HTML
   * @param  {Objeto} chart          Objeto de gráfico (Varia de acordo com o tipo de graáfico)
   * @param  {bool} changeInterval   Valor default para gráficos que permitem a alteração de intervalo
   */
  defineInterval(element, chart, changeInterval) {
    const interval = element.getAttribute('data-graphic-interval');
    switch (interval) {
      case 'yearly':
        chart.prepareDataYearly();
        this.addEventListenerInterval(changeInterval);
        break;
      case 'quarterly':
        chart.prepareDataQuarterly();
        this.addEventListenerInterval(changeInterval);
        break;
      case 'monthly':
        chart.prepareDataMonthly();
        this.addEventListenerInterval(changeInterval);
        break;
      default:
        let limitColumns = element.getAttribute('data-graphic-limit');
        let sumOthersColumns = element.getAttribute('data-graphic-sum-others');
        sumOthersColumns = sumOthersColumns ? true : false;
        limitColumns = limitColumns ? limitColumns : 10;
        chart.prepareDataGraphicCommon(parseInt(limitColumns), sumOthersColumns);
        break;
    }
  }

  /**
   * Instancia a Classe do Tipo de Gráfico
   * Basicamente da um New na classe pertinente ao gráfico
   * que informado como tipo no atributo data-graphic-type
   *
   * @param  {string} graphicType Tipo de Gráfico
   * @param  {element} element      Elemento HTML
   * @param  {Object} data          Dados que irão ser exibido no gráfico
   * @return {Object}               Objeto da Classe do Tipo de Gráfico
   */
  instaceClassGraphic(graphicType, element, data) {
    let chart = false;
    graphicType = graphicType.charAt(0).toUpperCase() + graphicType.slice(1);
    switch (graphicType) {
      case 'Stack':
        chart = new Stack(element, data);
        break;
      case 'ByType':
        chart = new ByType(element, data);
        break;
      case 'Horizontal':
        chart = new Horizontal(element, data);
        break;
      case 'Bar':
        chart = new Bar(element, data);
        break;
      default:
        console.error('O tipo de gráfico precisar ser (Stack/Pie/Horizontal/Bar em: ', element);
        break;
    }
    return chart;
  }

  /**
   * Método de criação do gráfico
   * Primeiro ele chama ao método que faz a instância do
   * tipo de gráfico, caso esta tenha sido realizada com
   * sucesso, ele chama o método para a definição do intervalo
   * atribui os dados que faltavam na forma do objeto graphics
   * da classe, como a classe que o gráfico percente, e o próprio
   * gráfico em questão, para que ele possa ser destruído e recriado
   * por outros métodos em outras situações
   * @param  {graphics} graphic      Gráfico a ser trabalho (Dentro do atributo de Classe)
   * @param  {Object} data           Dados do gráfico
   * @param  {bool} changeInterval   alteração de intervalo default null
   */
  createGraphic(graphic, data, changeInterval = null) {
    const graphicType = graphic.graphicType;
    const nameGraphic = graphic.nameGraphic;
    const element = graphic.element;
    const chart = this.instaceClassGraphic(graphicType, element, data);
    if (chart) {
      this.defineInterval(element, chart, changeInterval);
      this.graphics[nameGraphic].classObject = chart;
      this.graphics[nameGraphic].graphic = chart.createChart();
      this.graphicCreated(element);
    }
  }
}
export default Graphics;
